import React from 'react';
import { Box, Typography } from '@mui/material';
import { Log, useTranslation } from "@fanfanlo";
import { TranslationComponent } from '@fanfanlo/translation';
import { DescriptionContentType, IDescriptionContent, SourceLanguage } from '../../common/IEntityDescription';
import { validateUrl } from '../../utils/descriptionUtils';

const fileLog = new Log(false, 'DescriptionContentRenderer_ui');
fileLog.pause = true;
fileLog.childrenPaused = true;

export interface DescriptionContentRendererProps {
    data?: IDescriptionContent
    sourceLang?: SourceLanguage
    className?: string
}

export function DescriptionContentRenderer(props: DescriptionContentRendererProps) {
    const uiLog = fileLog.sub(false, 'DescriptionContentRenderer_ui');
    uiLog.pause = true;

    const { t } = useTranslation('droid/project-v2-interface/components/description-renderer/content');

    const { data, sourceLang = 'auto', className } = props;

    uiLog.log('渲染DescriptionContentRenderer, data:', data, 'sourceLang:', sourceLang);

    if (!data) {
        uiLog.log('data为null, 不渲染');
        return null;
    }

    if (!data.content) {
        uiLog.log('data.content为空, 不渲染');
        return null;
    }

    const contentType = data.type;
    const content = data.content;

    uiLog.log('contentType:', contentType, 'content:', content);

    if (contentType === DescriptionContentType.TEXT) {
        uiLog.log('渲染TEXT类型, 使用TranslationComponent');
        return (
            <Box className={className}>
                <TranslationComponent sourceLang={sourceLang}>
                    <Typography>
                        {content}
                    </Typography>
                </TranslationComponent>
            </Box>
        );
    }

    if (contentType === DescriptionContentType.HTML) {
        uiLog.log('渲染HTML类型, 使用TranslationComponent isHtml');
        return (
            <Box className={className}>
                <TranslationComponent sourceLang={sourceLang} isHtml={true}>
                    {content}
                </TranslationComponent>
            </Box>
        );
    }

    if (contentType === DescriptionContentType.URL) {
        uiLog.log('渲染URL类型');

        const isValid = validateUrl(content);
        uiLog.log('URL是否有效:', isValid);

        if (!isValid) {
            uiLog.error('URL无效:', content);
            return (
                <Box className={className}>
                    <Typography color="error">
                        {t('DescriptionContentRenderer.invalidUrl', { url: content })}
                    </Typography>
                </Box>
            );
        }

        return (
            <Box className={className}>
                <iframe
                    sandbox="allow-scripts"
                    src={content}
                    style={{
                        width: '100%',
                        minHeight: '400px',
                        border: '1px solid #e0e0e0',
                        borderRadius: '4px'
                    }}
                    title="URL Content"
                />
            </Box>
        );
    }

    uiLog.error('未知的contentType:', contentType);
    return (
        <Box className={className}>
            <Typography color="error">
                {t('DescriptionContentRenderer.unknownType', { type: contentType })}
            </Typography>
        </Box>
    );
}
